"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.json = exports.bool = exports.nonemptyString = exports.finiteNumber = exports.listOf = void 0;
function listOf(itemParser) {
    return (raw) => raw
        .split(",")
        .map((rawItem) => rawItem.trim())
        .filter((rawItem) => rawItem !== "")
        .map(itemParser);
}
exports.listOf = listOf;
const finiteNumber = (raw) => {
    const parsed = Number(raw);
    if (isNaN(parsed)) {
        throw new Error(`Unable to parse ${raw} as a finite number.`);
    }
    else {
        return parsed;
    }
};
exports.finiteNumber = finiteNumber;
const nonemptyString = (raw) => {
    if (raw) {
        return raw;
    }
    else {
        throw new Error(`string env var was empty`);
    }
};
exports.nonemptyString = nonemptyString;
const bool = (raw) => {
    const parsed = raw === "true";
    if (parsed) {
        return parsed;
    }
    else if (raw === "false") {
        return false;
    }
    else {
        throw new Error(`Unable to parse ${raw} as a boolean.`);
    }
};
exports.bool = bool;
const json = (raw) => {
    return JSON.parse(raw);
};
exports.json = json;
//# sourceMappingURL=ParserUtils.js.map